// extracted by mini-css-extract-plugin
export default {"box":"workbench_box__qewkP","between":"workbench_between__q0YhH"};